// extracted by mini-css-extract-plugin
module.exports = {"description":"_2b_QrWlV","launchDateContainer":"elaTgCTa","calendarIcon":"JOzxUuNf"};